<div class="card-alert"
    *ngIf="type === 'alert' && checkId && !haveData && !authService?.getCompanySaaS()?.allowCreatingWithoutTruora">
    <div class="card-alert__icon">
        <i class="fas fa-exclamation-triangle"></i>
    </div>
    <div>
        <ng-container *ngIf="securityStudyStatus === 'Estudio de seguridad en proceso'; else studyCompleted">
            Estudio de Seguridad en Proceso, con datos faltantes, debido a que la base de datos del {{ outServiceDbs}}
            está temporalmente fuera de servicio
            <span *ngIf="additionalText">
                {{additionalText}}
            </span>
            <span *ngIf="allowedToActions">
                <span>
                    . Se puede
                </span>
                <span *ngIf="dataType !== 'arl' && dataType !=='eps' && canOverwriteVehicleInfo">
                    ingresar la información manualmente <u class="text-bold cursor-pointer"
                        (click)="emitServiceTrigger.emit(dataType)">aquí</u> o
                </span>
                <span *ngIf="dataType">
                    esperar a que el <u class="text-bold cursor-pointer" (click)="newSecurityStudy.emit(true)">estudio
                        de seguridad</u>.
                    termine su periodo de procesamiento
                </span>
            </span>
        </ng-container>

        <ng-template #studyCompleted>
            Estudio de Seguridad ha finalizado, con datos faltantes, debido a que la base de datos del {{
            outServiceDbs}} está temporalmente fuera de servicio
            cuando fue ejecutado
            <span *ngIf="additionalText">
                {{additionalText}}
            </span>
            <span *ngIf="allowedToActions">
                <span>. Se puede
                </span>
                <span *ngIf="dataType !== 'arl' && dataType !=='eps' && canOverwriteVehicleInfo">
                    ingresar la información manualmente <u class="text-bold cursor-pointer"
                        (click)="emitServiceTrigger.emit(dataType)">aquí</u> o
                </span>
                <span *ngIf="dataType">
                    lanzar un nuevo <u class="text-bold cursor-pointer" (click)="newSecurityStudy.emit(true)">estudio de
                        seguridad</u>.
                </span>
            </span>
        </ng-template>

    </div>
</div>
<button
    *ngIf="type === 'manualButton' && ((!checkId && authService?.getCompanySaaS()?.allowCreatingWithoutTruora && !haveData) || canOverwriteVehicleInfo || typeAction === 'createDriver') && licensesEnabled"
    class="manual-info-button button-width-auto secondary-sharp" mat-raised-button color="primary" type="button"
    (click)="emitServiceTrigger.emit(dataType)">
    <span *ngIf="dataType && dataType ==='license'; else editData">
        <i class="fas fa-plus-circle"></i>
        Agregar licencia
    </span>
    <ng-template #editData>
        Editar datos
        <i class="fas fa-pencil-alt"></i>
    </ng-template>
</button>